"use strict";
// partsから必要分のみimport

import "./parts/_accordion.js";
import "./parts/_countUp.js";
import "./parts/_drawer.js";
import "./parts/_fixed-viewport.js";
import "./parts/_observer.js";
import "./parts/_parallax.js";
import "./parts/_scroll-header.js";
import "./parts/_slider.js";
import "./parts/_sticky-scroll.js";
import "./parts/_vivus.js";
